/**
 * Firme iz zajedničke trake/zaglavlja (store: report/selectedMealCompanies) za ekran koji nasleđuje stari tab
 * sa sopstvenim izborom firmi u `selectedCompanies`. Početni izbor je već iz store-a, pa se tab učitava
 * jednom, sa pravim firmama.
 */
export default {
  data() {
    return { selectedCompanies: [...(this.$store.state.report.selectedMealCompanies || [])] };
  },
  computed: {
    barCompanies() {
      return this.$store.state.report.selectedMealCompanies || [];
    },
  },
  watch: {
    barCompanies(companies) {
      this.selectedCompanies = [...companies];
    },
  },
};
